export default __webpack_public_path__ + "static/media/comfort.507846c5.svg";